<svelte:head>
  <title>{scoped.data?.name || 'Offer'} | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="block is-size-7">
  <a href={$url('../../offers')}> &lt; Back to all offers</a>
</div>

{#if scoped.data && scoped.requests}
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">
          {scoped.data.name}
          <span class="tag is-small">{scoped.data.status}</span>
        </h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right">
      {#if scoped.data.status === 'published'}
        <button
          class="button"
          on:click={() =>
            ($uiState.activeModal = {
              component: ConfirmClose,
              props: { id: id }
            })}>
          <span>End offer</span>
        </button>
      {/if}

      {#if stage === 'details'}
        <button
          class="button"
          on:click={() => {
            $uiState.activeModal = {
              component: ConfirmDelete,
              props: { item: { data: scoped.data, id }, navPath }
            };
          }}>
          Delete
        </button>
      {/if}
    </div>
  </nav>

  <div class="tabs">
    <ul>
      <Tab page="details" label="Details" />
      <Tab isDisabled={stage == 'details'} page="requests" label="Requests" />
      <Tab
        page="matches"
        isDisabled={stage == 'details' || stage == 'requests'}
        label={singleMatchOffer ? 'Match' : 'Matches'} />
    </ul>
  </div>

  <slot {scoped} />
{/if}

<script lang="ts">
  export let id: OfferId;
  import { appState } from '../../../../lib/appState';
  import { uiState } from '../../../../lib/uiState';
  import { params } from '@sveltech/routify';
  import { url } from '@sveltech/routify';
  import _ from 'lodash';

  import Tab from './_components/Tab.svelte';
  import ConfirmClose from './_components/ConfirmClose.svelte';
  import ConfirmDelete from './_components/ConfirmDelete.svelte';

  let firebase = window.firebase;

  let stage: 'details' | 'requests' | 'matches' | undefined;

  let navPath = '/business/offers';
  let scoped: ScopedOfferState;
  // create object that can be passed to child pages
  $: scoped = {
    id,
  };

  $: if (scoped.data && scoped.requests) {
    const status: OfferStatus = scoped.data.status;
    if (
      status === 'draft' ||
      status === 'pending-approval' ||
      status === undefined
    ) {
      stage = 'details';
    } else if (
      scoped.requests.find(
        (req: Request_v2_Doc) =>
          req.data.status === 'selected' ||
          req.data.status === 'matched' ||
          req.data.status === 'completed' ||
          req.data.status === 'failed'
      )
    ) {
      stage = 'matches';
    } else {
      stage = 'requests';
    }

    if ($params.action === 'end' && scoped.data.status === 'published') {
      $uiState.activeModal = {
        component: ConfirmClose,
        props: { id: id }
      };
    }
  }

  let singleMatchOffer = false;

  getOffer();

  function getOffer() {
    firebase
      .firestore()
      .collection('offers_v2')
      .doc(id)
      .onSnapshot((doc) => {
        scoped.data = doc.data() as Offer_v2;
        singleMatchOffer = scoped.data?.options.divisible !== true;
      });
  }

  getRequests();

  function getRequests() {
    firebase
      .firestore()
      .collection('requests_v2')
      .where('offer', '==', id)
      .onSnapshot((snap) => {
        scoped.requests = snap.docs.map((doc) => ({
          id: doc.id,
          data: doc.data() as Request_v2
        }));
      });
  }

  $: if (scoped.requests && !scoped.unreadMessages) {
    getUnreadMessages();
  }

  async function getUnreadMessages() {
    const db = firebase.firestore();
    const promiseRefs = scoped.requests?.flatMap((request) => {
      if (!request.data.messages) {
        return [];
      }
      return request.data.messages?.map((id) => {
        const docRef = db.doc(`messages_v1/${id}`);
        return { ref: docRef.get(), requestId: request.id };
      });
    });

    if (promiseRefs && promiseRefs.length > 0) {
      scoped.unreadMessages = (await getMessageStatus(
        promiseRefs
      ) as UnreadMessage[]);
    } else {
      scoped.unreadMessages = []
    }
  }

  async function getMessageStatus(
    refs: {
      ref: Promise<
        firebase.firestore.DocumentSnapshot<firebase.firestore.DocumentData>
      >;
      requestId: string;
    }[]
  ) {
    try {
      const snapshots = await Promise.all(refs.map((promise) => promise.ref));

      return snapshots.map((docSnapshot, index) => {
        if (
          docSnapshot.data() &&
          !(docSnapshot.data()!).isRead &&
          (docSnapshot.data()!).userId != $appState.auth_user.email
        ) {
          return {
            requestId: refs[index].requestId,
            offerId: scoped.id
          };
        } else return {};
      });
    } catch (error) {
      console.error('Error getting documents:', error);
    }
  }
</script>
